// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectorRow_row__63HBg {
  display: flex;
  gap: 1rem;
}

.SelectorRow_label__u2Nva {
  flex: 1 1;
}

.SelectorRow_container__iqBFV {
  width: 16rem;
}`, "",{"version":3,"sources":["webpack://./src/components/PortalModal/SelectorRow.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EAAS,SAAA;AAET;;AADA;EAAa,YAAA;AAKb","sourcesContent":[".row {\n  display: flex;\n  gap: 1rem;\n}\n\n.label {\n  flex: 1;\n}\n\n.container {\n  width: 16rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `SelectorRow_row__63HBg`,
	"label": `SelectorRow_label__u2Nva`,
	"container": `SelectorRow_container__iqBFV`
};
export default ___CSS_LOADER_EXPORT___;
